import { OxGristEditor } from './ox-grist-editor.js'
import { customElement } from 'lit/decorators.js'
import { html } from 'lit'

@customElement('ox-grist-editor-color')
export class OxGristEditorColor extends OxGristEditor {
  /*
   * color input 인 경우에는, color picker에서 change 이벤트가 발생하지 않기 때문에, input 이벤트를 사용하여
   * value가 변경되었음을 알림
   */
  get editorTemplate() {
    return html`
      <input
        type="color"
        .value=${this.value}
        @input=${(e: Event) =>
          (e.currentTarget as HTMLElement).dispatchEvent(
            new CustomEvent('change', {
              bubbles: true,
              composed: true
            })
          )}
      />
    `
  }
}
